import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';

@Component({
  selector: 'opac-infinite-scroll',
  templateUrl: './infinite-scroll.component.html',
  styleUrls: ['./infinite-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfiniteScrollComponent implements AfterViewInit, OnDestroy, OnInit {
  private readonly intersectionObserver: IntersectionObserver;

  @Input() disabled: boolean = false;
  @Input() threshold: number = 0;
  @Output() load = new EventEmitter<void>();

  readonly showButton = signal<boolean>(false);

  constructor(
    private elementRef: ElementRef,
  ) {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (!this.disabled) {
        this.checkForIntersection(entries);
      }
    }, {
      rootMargin: this.threshold + 'px',
    });
  }

  ngOnInit(): void {
    this.showButton.set(this.isElementInViewport());
  }

  ngAfterViewInit() {
    this.intersectionObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.intersectionObserver.unobserve(this.elementRef.nativeElement);
    this.intersectionObserver.disconnect();
  }

  private isElementInViewport(): boolean {
    const rect: DOMRect = this.elementRef.nativeElement.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  private checkForIntersection(entries: IntersectionObserverEntry[]) {
    if (entries.some(entry => this.checkIfIntersecting(entry))) {
      this.showButton.set(true);
      this.load.emit();
    } else {
      this.showButton.set(false);
    }
  }

  private checkIfIntersecting(entry: IntersectionObserverEntry) {
    return entry.isIntersecting && entry.target === this.elementRef.nativeElement;
  }
}
